export const multiplesOf = (songsLength: number): boolean | undefined => {
  let paginationMultiples: boolean | undefined;
  const pageSongLimit = 40;
  if (songsLength === pageSongLimit) {
    paginationMultiples = true;
  }
  if (songsLength % pageSongLimit === 0) {
    paginationMultiples = true;
  }
  return paginationMultiples;
};
